import {INewSlotPress, ITableInteractionsState} from 'floorplan-v2/app/reducers/tableInteractions/types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {IBooking} from "shared-types/SharedTypes";
import {IFloorplanTableCalculated} from "floorplan-v2/app/services/PositionService/types";

const initialState: ITableInteractionsState = {
  currentTableId: '',
  pressedBooking: null,
  conflictedBookings: [],
  isConflict: false,
  pressedTable: null,
  newSlotPress: null
}
const tableInteractionsSlice = createSlice({
  name: 'tableInteractions',
  initialState,
  reducers: {
    setCurrentTableId: (state, action: PayloadAction<string>) => {
      state.currentTableId = action.payload;
    },
    setPressedBooking: (state, action: PayloadAction<IBooking>) => {
      state.pressedBooking = action.payload;
    },
    setPressedTable: (state, action: PayloadAction<IFloorplanTableCalculated>) => {
      state.pressedTable = action.payload;
    },
    setConflictedBookings: (state, action: PayloadAction<IBooking[]>) => {
      state.conflictedBookings = action.payload;
    },
    setIsConflict: (state, action: PayloadAction<boolean>) => {
      state.isConflict = action.payload;
    },
    setNewSlotPress: (state, action: PayloadAction<INewSlotPress>) => {
      state.newSlotPress = action.payload;
    },
    resetTablePress: (state) => {
      state.pressedBooking = null;
      state.pressedTable = null;
      state.newSlotPress = null;
    }
  },
});
const actions = tableInteractionsSlice.actions;
export { actions as tableInteractionsActions };
export default tableInteractionsSlice.reducer;

